angular.module('app.filters').filter('initials', () => (x) => {
    if (x) {
        return x
            .split(' ')
            .map((s) => s.charAt(0))
            .join('');
    } else {
        return null;
    }
});
